// extracted by mini-css-extract-plugin
module.exports = {"staticMapRoot":"DirectionsMap_staticMapRoot__PWGu_"};